export default __webpack_public_path__ + "static/media/art-0-mound.23ee5fba.jpeg";